<template>
    <div class="Item">
        <headerItem msg="授信结果" bgColor="" titleBeforeColor="" rightIcon=""></headerItem>
        <div class="container">
            <div class="d-flex " style="width: 100%">
                <!-- <div class="pro-item d-flex fl-dir-column"
                v-for="item in creditList" :style="{width: `${item.value1}%`, background: item.bg}">
                    <div>{{ item.name }} {{ item.value2 }}</div>
                    <div class="flex-1">{{ item.value1 }}%</div>
                </div> -->
                <div class="pro-item d-flex fl-dir-column text-l ju-center pl-10" v-show="data"
                    :style="{ width: `${creditList[0].value1}%`, background: `${creditList[0].bg}`, color: `${creditList[0].color}` }">
                    <div>通过 {{ data[0].value1 }}</div>
                    <div> {{ data[0].value2 }}%</div>
                </div>
                <div style="width: 4%;"></div>
                <div class="pro-item  d-flex fl-dir-column text-r ju-center pr-10" v-show="data"
                    :style="{ width: `${creditList[1].value1}%`, background: `${creditList[1].bg}`, color: `${creditList[1].color}` }">
                    <div>{{ data[1].value1 }} 拒绝</div>
                    <div> {{ data[1].value2 }}%</div>
                </div>
            </div>
            <div>
                <dv-scroll-board class="f-10" :config="config" :waitTime="2000000" style="width: 100%; height: 300px;" />
            </div>
        </div>
    </div>
</template>

<script>
import headerItem from '../components/headerItem.vue';
export default {
    name: '',
    components: {
        headerItem
    },
    props: {
        current: Number,
    },
    watch: {
        current(newVal, oldVal) {
            if (newVal === 1) {
                this.config = this.config1
                this.data = this.data1
            } else if (newVal === 0) {
                this.config = this.config0
                this.data = this.data0
            }
        }
    },
    data() {
        return {
            creditList: [
                { name: '通过', value1: '62.2', value2: '34739', bg: 'rgba(32, 149, 229, .5)', color: 'rgba(4, 158, 234, 1)' },
                { name: '拒绝', value1: '38.2', value2: '20483', bg: 'rgba(197, 29, 57, .5)', color: 'rgba(237, 29, 8, 1)' }
            ],
            config: {},
            config0: {
                header: ['拒绝原因', '笔数', '百分比'],
                headerBGC: 'transparent',
                data: [
                    ['关联人近5年存在被告裁判文书信息', "<span style='color: red'>194</span>", '5.1%'],
                    ['客户近24个月汇总累计逾期过多', "<span style='color: red'>167</span>", '4.8%'],
                    ['客户有当前逾期账户', "<span style='color: red'>123</span>", '3.5%'],
                    ['客户命中过往不良行为', "<span  style='color: red'>117</span>", '2.6%'],
                    ['客户贷款融资机构数过多（除本行）', "<span style='color: red'>88</span>", '2.5%'],
                    ['客户非抵质押贷款机构数过多', "<span style='color: red'>78</span>", '2.6%'],
                    ['客户近5年存在未结案执行公告信息', "<span style='color: red'>95</span>", '2.1%'],
                    ['客户存在不良贷款', "<span style='color: red'>61</span>", '1.7%'],
                ],
                oddRowBGC: 'transparent',
                evenRowBGC: 'rgba(13, 15, 20, 1)',
                index: true,
                align: ['center']
            },
            config1: {
                header: ['拒绝原因', '笔数', '百分比'],
                headerBGC: 'transparent',
                data: [
                    ['客户非抵质押贷款机构数过多', "<span style='color: red'>1195</span>", '8.5%'],
                    ['客户贷款融资机构数过多（除本行）', "<span style='color: red'>1020</span>", '7.3%'],
                    ['客户近24个月汇总累计逾期过多', "<span style='color: red'>769</span>", '5.5%'],
                    ['客户近5年存在未结案执行公告信息', "<span  style='color: red'>948</span>", '5.1%'],
                    ['客户有余额的信用卡张数过多', "<span style='color: red'>538</span>", '3.8%'],
                    ['关联人近5年存在未结案执行公告信息', "<span style='color: red'>300</span>", '2.2%']
                ],
                oddRowBGC: 'transparent',
                evenRowBGC: 'rgba(13, 15, 20, 1)',
                index: true,
                align: ['center']
            },
            data: [
                {value1: '', value2: ''},
                {value1: '', value2: ''}
            ],
            data0: [
                {value1: '34739', value2: '62.2'},
                {value1: '34739', value2: '37.2'}
            ],
            data1: [
                {value1: '24739', value2: '88.2'},
                {value1: '22739', value2: '11.7'},
            ],
        }
    },
    mounted() {
        this.data = this.data0
        this.config = this.config0
	},
}
</script>

<style lang="less" scoped>
.dv-scroll-board-row-index {
  color: red; /* 序号颜色 */
  font-weight: bold; /* 序号字体加粗 */
}
.Item {
    font-size: 36px;
    .container {
        width: 100%;
        padding-top: 10px;

        // background: red;
        .pro-item {
            height: 180px;
        }

        .pl-10 {
            padding-left: 10px;
        }

        .pr-10 {
            padding-right: 10px;
        }
    }
}
</style>
